import React from "react";
import styles from "./HomePage.module.css";
import WelcomeInfoBox from "components/WelcomeInfoBox";

export function HomePage() {
  return <WelcomeInfoBox />;
}

export default HomePage;
